// SIEM.js
import React from 'react';
import { Link } from 'react-router-dom';

const SIEM = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 className="card-title">You are ahead of your time</h1>
      <p className="card-text">This feature is currently being built with the expertise of cybersecurity professionals.<br />We deploy open-source tools to let you can keep track of<br />your office machines for any cyber incidents on your premises.<br /><br /><b>No cloud. No remote. Fully private.</b><br />Check back again later! </p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default SIEM;
